

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { GET_EXPORT_BY_ID, IS_LOGGED_IN, LOGOUT } from '@/store';
import Footer from '@/components/Footer.vue';
import ExportList from '@/components/ExportList.vue';

@Component({
  components: {
    Footer,
    ExportList
  }
})
export default class Home extends Vue {
  apiError: string = '';
  loading = false;
  mounted() {
    if (this.isAuthenticated) {
      this.loading = true;
      this.$store
        .dispatch(GET_EXPORT_BY_ID, this.$route.params.id)
        .catch(error => {
          if (error) {
            this.apiError = error;
          }
        })
        .finally(() => (this.loading = false));
    }
  }

  get isAuthenticated() {
    return this.$store.getters[IS_LOGGED_IN];
  }

  logout() {
    this.$store.dispatch(LOGOUT);
  }
}
